export const getNewCrumbs = (url: string) => {
    const slugs = url === '/' ? [''] : url.split('/');

    return slugs
        .map(c => '/' + c)
        .reduce<string[]>((acc, curr, index) => {
            return [...acc, (acc[index - 1] || '') + curr];
        }, [])
        .map(c => c.replace('//', '/'));
};
